<jw-modal id='jobSignOffLandEditJobModal'>
    <app-job-signoff-land-view [isPopup]='true' [mode]="this.mode"></app-job-signoff-land-view>
</jw-modal>
